<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { required, requiredIf } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import SLModal from "@/components/modals/create-sl.vue";
import JevTable from "@/components/tables/jev-entry-table.vue";
import PrintOptions from "@/components/modals/print-options";
import CashierTemplates from "@/components/widgets/cashier-template-widget.vue";
export default {
  page: {
    title: "JEV Entries",
  },
  components: {
    AvailableDisbursementsModal: () =>
      import(
        /* webpackChunkName: "modal" */ "@/components/modals/available-disbursement.vue"
      ),
    ResponsibilityCenter: () =>
      import(
        /* webpackChunkName: "modal" */ "@/components/modals/responsibility-center.vue"
      ),
    SubsidiaryLedgerList: () =>
      import(
        /* webpackChunkName: "table" */ "@/components/widgets/sl-list.vue"
      ),
    DatePicker,
    Multiselect,
    MaskedInput,
    Layout,
    PageHeader,
    SLModal,
    JevTable,
    PrintOptions,
    CashierTemplates,
  },
  props: {
    isJevLoaded: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
      }),
      title: "JEV Entries",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "JEV Entries",
          active: true,
        },
      ],
      fields: [
        {
          key: "items",
          label: " ",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "jevDate",
          label: "JEV Date",
          sortable: true,
        },
        {
          key: "jevNumber",
        },
        {
          key: "description",
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        {
          key: "isPosted",
          label: "Status",
          sortable: true,
        },
        {
          key: "actions",
        },
      ],
      jevEntries: [],
      cycle: Number(this.$store.getters["data/getCycle"]),
      jevTypes: [
        "CHR - Cash Receipt",
        "CHD - Cash Disbursement",
        "CKD - Check Disbursement",
        "ADA - Auto Debit Account Disbursement",
        "GEJ - General Entry",
      ],
      jevTypeOptions: [
        { value: null, text: "Select JEV Entry Type...", disabled: true },
        { value: "chr", text: "Cash Receipt" },
        { value: "chd", text: "Cash Disbursement" },
        { value: "ckd", text: "Check Disbursement" },
        { value: "ada", text: "Auto Debit Account Disbursement" },
        { value: "gej", text: "General Entry" },
      ],
      selectedJevTypeOption: null,
      availableDisbursements: [],
      campusAccessList: [],
      accounts: [],
      subsidiaryAccountIndex: [
        {
          jevId: 0,
          name: "",
          debit: "0",
          credit: "0",
        },
      ],
      fundClusterAccessList: [],
      fcOptions: [],
      clusterOptions: [],
      accountOptions: [],
      fundSources: [],
      alert: {
        show: false,
        type: "",
        message: "",
      },
      newJevEntry: {
        id: 0,
        jevNumber: null,
        jevDate: new Date().toISOString(),
        responsibilityCenter: null,
        description: null,
        type: "CHR - Cash Receipt",
        cycle: Number(this.$store.getters["data/getCycle"]),
        fundSourceId: null,
        dvNumber: null,
        orNumber: null,
        orDate: new Date(),
        checkNumber: null,
        checkDate: new Date(),
        checkBankName: null,
        reviewingReport: "",
        notes: "",
      },
      jevEntryDetails: [
        {
          accountId: "",
          debit: "0",
          credit: "0",
          isSundry: false,
        },
      ],
      monthReports: [
        { value: null, text: "Select Month....", disabled: true },
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 10, text: "November" },
        { value: 11, text: "December" },
      ],
      selectedJev: null,
      submitted: false,
      newJevEntryModal: false,
      editJevEntryModal: false,
      forCheck: false,
      modalTitle: "",
      selectedCampus: this.$store.state.data.selectedCampus.id,
      uploadSubsidiary: false,
      jevEntryIndex: 0,
      actor: "Officer",
      isOutgoing: false,
      previousCredit: "",
      selectedCluster: null,
      selectedJevType: null,
      selectedAccount: null,
      subsidiaryLedgers: [],
      selectedSL: null,
      chr: [],
      chd: [],
      ckd: [],
      ada: [],
      gej: [],
      monthModal: false,
      hideDisbursement: false,
      selectedFundCluster: null,
      selectedMonth: null,
      selectedPrint: null,
      selectedJevEntry: null,
      selectedSLForPosting: null,
      generatedJEV: {
        id: null,
        jevNumber: null,
        type: null,
      },
    };
  },
  validations: {
    newJevEntry: {
      responsibilityCenter: { required },
      description: { required },
      fundSourceId: { required },
      type: { required },
      dvNumber: {
        required: requiredIf(function() {
          return (
            !this.newJevEntry.type.toLowerCase().includes("chr") &&
            !this.newJevEntry.type.toLowerCase().includes("gej")
          );
        }),
      },
      orNumber: {
        required: requiredIf(function() {
          return this.newJevEntry.type.toLowerCase().includes("chr");
        }),
      },
      orDate: {
        required: requiredIf(function() {
          return this.newJevEntry.type.toLowerCase().includes("chr");
        }),
      },
      payee: {
        required: requiredIf(function() {
          return !this.newJevEntry.type.toLowerCase().includes("gej");
        }),
      },
      checkNumber: {
        required: requiredIf(function() {
          return (
            this.newJevEntry.type.toLowerCase().includes("ckd") ||
            this.newJevEntry.type.toLowerCase().includes("ada")
          );
        }),
      },
      checkDate: {
        required: requiredIf(function() {
          return (
            this.newJevEntry.type.toLowerCase().includes("ckd") ||
            this.newJevEntry.type.toLowerCase().includes("ada")
          );
        }),
      },
      checkBankName: {
        required: requiredIf(function() {
          return (
            this.newJevEntry.type.toLowerCase().includes("ckd") ||
            this.newJevEntry.type.toLowerCase().includes("ada")
          );
        }),
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    updateFilterStatus() {
      this.$refs.jevtable.updateStatus();
    },
    clearFields() {
      this.newJevEntry = {
        id: 0,
        jevNumber: null,
        jevDate: Date.now(),
        responsibilityCenter: null,
        description: null,
        type: "CHR - Cash Receipt",
        cycle: Number(this.$store.getters["data/getCycle"]),
        fundSourceId: null,
        dvNumber: null,
        orNumber: null,
        orDate: new Date(),
        checkNumber: null,
        checkDate: new Date(),
        checkBankName: null,
        reviewingReport: "",
        notes: "",
      };

      this.jevEntryDetails = [
        {
          accountId: "",
          debit: "0",
          credit: "0",
          isSundry: false,
        },
      ];
      this.toggleCheck();
      this.fetchSubsidiaryLedgers();
      this.selectedSL = null;
    },
    removeSelectedSL() {
      this.$swal({
        title: "Are you sure?",
        text:
          "You are now removing this subsidiary ledger in this JEV Entry. You can add this subsidiary ledger in this JEV entry again",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.selectedSL = null;
        }
      });
    },
    formatDate(data) {
      return new Date(data).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
    addAccountsFromTemplate(data) {
      this.$bvModal.hide("template-modal");
      // jevEntryDetails
      const items = data.cashierTemplateItems
        .filter((item) => item.active)
        .map((item) => ({
          accountId: {
            accountName: item.account.accountName,
            uacs: item.account.uacs,
            value: item.account.id,
          },
          debit: item.isDebit ? this.formatNumber(item.defaultAmount) : "0",
          credit: !item.isDebit ? this.formatNumber(item.defaultAmount) : "0",
          isSundry: false,
        }));
      this.jevEntryDetails.push(...items);
    },
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    fetchAvailableJev() {
      this.modalTitle = `New JEV Entry for cycle: ${this.newJevEntry.cycle}`;

      this.newJevEntryModal = true;
    },
    saveAndPostJev() {
      this.createJev(true);
    },
    createJev(forPosting) {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.newJevEntry.$invalid) {
        return;
      } else {
        this.$swal({
          title: "Are you sure?",
          text: `You are now ${
            this.newJevEntry.id === 0 ? "creating" : "updating"
          } this JEV entry. Make sure to completely fill out fields in JEV Details. Missing information will not be saved in a JEV detail will not be saved`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#28c76f",
          confirmButtonText: `Yes, ${
            this.newJevEntry.id === 0 ? "create" : "update"
          } it`,
        }).then((result) => {
          if (result.isConfirmed) {
            this.pageLoader(true);
            /** Do process here */
            const nData = JSON.parse(JSON.stringify(this.newJevEntry));
            const newJevDate = this.formatDateToISO(this.newJevEntry.jevDate);
            nData.jevDate = newJevDate;
            nData.checkDate =
              this.newJevEntry.checkDate instanceof Date
                ? this.formatDateToISO(this.newJevEntry.checkDate)
                : this.newJevEntry.checkDate;
            nData.orDate =
              this.newJevEntry.orDate instanceof Date
                ? this.formatDateToISO(this.newJevEntry.orDate)
                : this.newJevEntry.orDate;
            /** split newJevEntry.type and get the first element  */
            nData.type = this.newJevEntry.type.split(" - ")[0];

            const processJevEntryDetails = this.jevEntryDetails.map((item) => ({
              accountId: item.accountId ? item.accountId.value : 0,
              debit: item.debit ? Number(this.getExactAmt(item.debit)) : 0,
              credit: item.credit ? Number(this.getExactAmt(item.credit)) : 0,
              isSundry: item.isSundry,
            }));

            /** check if accountCode, debit, credit and payee has value in processJevEntryDetails using javascript some */
            const hasAccountCode = processJevEntryDetails.some(
              (jevEntryDetail) => jevEntryDetail.accountId === 0
            );

            if (hasAccountCode) {
              this.pageLoader(false);
              this.$swal({
                title: "Ooops!",
                text:
                  "It seems that you missed to fill out the Account info in JEV Details. Make sure to fill out necessary fields",
                icon: "error",
                confirmButtonColor: "#7367f0",
              });
              return;
            }

            /** sum up all debit in processJevEntryDetails */
            const totalDebit = processJevEntryDetails.reduce(
              (acc, curr) => acc + curr.debit,
              0
            );

            /** sum up all credit in processJevEntryDetails */
            const totalCredit = processJevEntryDetails.reduce(
              (acc, curr) => acc + curr.credit,
              0
            );

            if (totalDebit !== totalCredit) {
              this.pageLoader(false);
              this.$swal({
                title: "Ooops!",
                text:
                  "It seems that you your debit and credit is not balanced. Make sure to make them balance to continue",
                icon: "error",
                confirmButtonColor: "#7367f0",
              });
              return;
            }

            /** Save Jev Entry */
            /** process data after JEV Entry is saved */
            if (nData.id === 0) {
              this.$store
                .dispatch("jev/addJevEntry", {
                  campusId: this.selectedCampus,
                  data: nData,
                })
                .then((response) => {
                  if (response.data.error) {
                    this.showToast(response.data.errorMessage, "error");
                    return;
                  }
                  if (!response.data) {
                    this.showToast(
                      "Process cannot continue creating the JEV Entry. Please contact your administrator",
                      "error"
                    );
                    return;
                  }
                  const responseData = response.data;
                  const jevEntryId = response.data.id;
                  this.$store
                    .dispatch("jev/addJevDetails", {
                      jevEntryId: response.data.id,
                      data: processJevEntryDetails,
                    })
                    .then((response) => {
                      if (response.data.error) {
                        this.showToast(response.data.errorMessage, "error");
                        return;
                      }
                      this.newJevEntryModal = false;
                      if (forPosting) {
                        this.showJevModal(responseData);
                      }
                      if (this.selectedSL) {
                        /** create SL Item */
                        this.$store
                          .dispatch(
                            "subsidiaryledger/createSubsidiaryLedgerItem",
                            {
                              subsidiaryLedgerId: this.selectedSL.id,
                              jevEntryId: jevEntryId,
                            }
                          )
                          .then((response) => {
                            if (response.data.error) {
                              return this.showToast(
                                response.data.errorMessage,
                                "error"
                              );
                            }
                          })
                          .catch((error) => {
                            console.log(error);
                            this.showToast(
                              "There was an error creating the SL Item. Please contact your administrator",
                              "error"
                            );
                          });
                      }
                      this.pageLoader(false);
                      this.fetchAllJEV();
                      this.clearFields();
                      this.showToast("Successfully created JEV", "success");
                    })
                    .catch((error) => {
                      console.log(error);
                      this.showToast(
                        "There was an error creating the JEV Entry Details. Please contact your administrator",
                        "error"
                      );
                    });
                })
                .catch((error) => {
                  this.newJevEntryModal = false;
                  this.showToast(
                    "There was an error creating the JEV Entry. Please contact your administrator",
                    "error"
                  );
                });
            } else {
              /** Update JEV Entry */
              this.$store
                .dispatch("jev/updateJevEntry", { id: nData.id, data: nData })
                .then((response) => {
                  if (response.data.error) {
                    this.showToast(response.data.errorMessage, "error");
                    return;
                  }
                  this.$store
                    .dispatch("jev/addJevDetails", {
                      jevEntryId: nData.id,
                      data: processJevEntryDetails,
                    })
                    .then((response) => {
                      if (response.data.error) {
                        this.showToast(response.data.errorMessage, "error");
                        return;
                      }
                      this.newJevEntryModal = false;
                      if (forPosting) {
                        this.showJevModal(nData);
                      }
                      if (this.selectedSL) {
                        /** create SL Item */
                        this.$store
                          .dispatch(
                            "subsidiaryledger/createSubsidiaryLedgerItem",
                            {
                              subsidiaryLedgerId: this.selectedSL.id,
                              jevEntryId: nData.id,
                            }
                          )
                          .then((response) => {
                            if (response.data.error) {
                              return this.showToast(
                                response.data.errorMessage,
                                "error"
                              );
                            }
                          })
                          .catch((error) => {
                            console.log(error);
                            this.showToast(
                              "There was an error creating the SL Item. Please contact your administrator",
                              "error"
                            );
                          });
                      }
                      this.pageLoader(false);
                      this.fetchAllJEV();
                      this.clearFields();
                      this.showToast("Successfully updated JEV", "success");
                    })
                    .catch((error) => {
                      console.log(error);
                      this.showToast(
                        "There was an error creating the JEV Entry Details. Please contact your administrator",
                        "error"
                      );
                    });
                })
                .catch((error) => {
                  this.newJevEntryModal = false;
                  this.showToast(
                    "There was an error creating the JEV Entry. Please contact your administrator",
                    "error"
                  );
                });
            }
          }
        });

        this.submitted = false;
        // this.newJevEntryModal = false;
        this.$v.$reset();
      }
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      if (row.item.showDetails) {
        row.toggleDetails();
        row.item.showDetails = !row.item.showDetails;
      } else {
        row.toggleDetails();
        row.item.showDetails = !row.item.showDetails;
      }
    },
    edit(data) {
      /** find jevtypes including data.type */

      this.modalTitle = "";
      this.newJevEntry = JSON.parse(JSON.stringify(data));
      this.newJevEntry.jevDate = new Date(this.newJevEntry.jevDate);
      this.newJevEntry.orDate = new Date(this.newJevEntry.orDate);
      this.newJevEntry.checkDate = new Date(this.newJevEntry.checkDate);

      this.newJevEntry.type = this.jevTypes.find((jevType) =>
        jevType.includes(data.type)
      );
      this.toggleCheck();
      this.selectedCluster = data.fundSource
        ? data.fundSource.fundClusterId
        : null;
      this.processFC(data.fundSource ? data.fundSource.fundClusterId : null);

      this.jevEntryDetails = data.jevDetails.map((item) => ({
        accountId: {
          value: item.account.id,
          uacs: item.account.uacs,
          accountName: item.account.accountName,
        },
        debit: item.debit.toString(),
        credit: item.credit.toString(),
        isSundry: item.isSundry,
      }));
      this.modalTitle = "Edit JEV Entry";
      this.newJevEntryModal = true;
    },
    deleteItem(data) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.pageLoader(true);
          // this.$emit("deleteJev", data.id);
          this.$store
            .dispatch("jev/removeJevEntry", data.id)
            .then((response) => {
              this.pageLoader(false);
              if (response.data.error) {
                this.showToast(response.data.errorMessage, "error");
                return;
              }
              this.fetchAllJEV();
              this.showToast("Successfully deleted JEV", "success");
            })
            .catch(() => {
              this.pageLoader(false);
              this.showToast("Cannot delete JEV", "error");
            });
        }
      });
    },
    addToSl(data) {
      this.selectedJevEntry = data;
      this.$bvModal.show("subsidiaryLedgerModalForPosting");
    },

    confirmAddtoSL(record) {
      this.selectedSLForPosting = record;
      this.$swal({
        title: "Are you sure?",
        html: `You are now adding JEV Entry (<span class="text-info">${this.selectedJevEntry.jevNumber}</span>) to <span class="text-warning">${record.title}</span>. Do you want to continue?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#7367f0",
        confirmButtonText: "Yes, continue it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$bvModal.hide("subsidiaryLedgerModalForPosting");
          this.$store
            .dispatch("subsidiaryledger/createSubsidiaryLedgerItem", {
              subsidiaryLedgerId: this.selectedSLForPosting.id,
              jevEntryId: this.selectedJevEntry.id,
            })
            .then((response) => {
              if (response.data.error) {
                return this.showToast(response.data.errorMessage, "error");
              }
            })
            .catch((error) => {
              console.log(error);
              this.showToast(
                "There was an error creating the SL Item. Please contact your administrator",
                "error"
              );
            });
        }
      });
    },
    viewItems(data) {
      data.item.showDetails = !data.item.showDetails;
      data.toggleDetails();
    },
    deleteDisbursement(data) {
      this.$store
        .dispatch("jev/deleteJevEntryItem", data.id)
        .then((response) => {
          if (response.data.error) {
            this.showToast(response.data.errorMessage, "error");
          } else {
            this.showToast("Disbursement successfully delete", "success");
            // this.$emit("spliceDisbursement", data);
            this.jevEntries
              .find((item) => item.id === data.jevEntryId)
              .jevEntryItems.splice(
                this.jevEntries
                  .find((item) => item.id === data.jevEntryId)
                  .jevEntryItems.findIndex((item) => item.id === data.id),
                1
              );
          }
        })
        .catch(() => {
          this.showToast("Something went wrong", "error");
        });
    },
    closeCreate() {
      this.$swal({
        title: "Are you sure?",
        text:
          "You are now closing this form. All filled out fields will not be saved. Are you sure you want to close this modal?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28c76f",
        confirmButtonText: "Yes, close it",
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitted = false;
          this.newJevEntryModal = false;
          this.clearFields();
        }
      });
    },
    getResponsibilityCenterList() {
      this.newJevEntry.responsibilityCenter = null;
    },
    customLabel({ uacs, accountName }) {
      return `${uacs} - ${accountName}`;
    },
    fetchAccounts() {
      this.$store
        .dispatch("accounts/getAllAccounts")
        .then((response) => {
          this.accounts = response.data.map((item) => ({
            value: item.id,
            uacs: item.uacs,
            accountName: item.accountName,
          }));
          this.accountOptions = response.data.map((item) => ({
            value: item.id,
            text: `${item.uacs} - ${item.accountName}`,
          }));
        })
        .catch(() => {
          this.showToast(
            "Cannot fetch accounts. Please contact your administrator",
            "error"
          );
        });
    },
    toggleCheck() {
      if (this.newJevEntry.type.toLowerCase().includes("gej")) {
        this.hideDisbursement = true;
      } else {
        this.hideDisbursement = false;
      }
      if (
        this.newJevEntry.type.toLowerCase().includes("check") ||
        this.newJevEntry.type.toLowerCase().includes("ada")
      ) {
        this.forCheck = true;
      } else {
        this.forCheck = false;
      }

      if (this.newJevEntry.type.toLowerCase().includes("chr")) {
        this.actor = "Collecting Officer";
        this.isOutgoing = false;
      } else {
        this.actor = "Disbursement Officer";
        this.isOutgoing = true;
      }

      if (this.newJevEntry.type.toLowerCase().includes("gej")) {
        this.forCheck = false;
        this.isOutgoing = true;
      }
    },
    searchDvNumber() {
      // this.jevEntryIndex = key;
      this.$bvModal.show("availableDisbursementsModal");
      //
    },
    selectDvNumber(data) {
      // this.jevEntryDetails[this.jevEntryIndex].dvNumber = data.disbursementNumber;
      this.newJevEntry.dvNumber = data.disbursementNumber;
      this.$bvModal.hide("availableDisbursementsModal");
      this.jevEntryIndex = 0;
    },
    searchResponsibilityCenter() {
      if (!this.selectedCampus) {
        this.showToast("Please select a campus first", "error");
        return;
      }
      this.$bvModal.show("responsibilityCenterModal");
    },
    selectResponsibilityCenter(data) {
      this.$swal({
        title: "Select code to use",
        html: `<p><span class="text-primary">${data.rcCodeGf} </span> - GF Code</p><p><span class="text-success">${data.rcCodeStf}</span> - STF Code</p>`,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#564ab1",
        confirmButtonText: "GF Code",
        cancelButtonColor: "#28c76f",
        cancelButtonText: "STF Code",
      }).then((result) => {
        if (result.isConfirmed) {
          this.newJevEntry.responsibilityCenter = data.rcCodeGf;
          this.$bvModal.hide("responsibilityCenterModal");
        } else {
          this.newJevEntry.responsibilityCenter = data.rcCodeStf;
          this.$bvModal.hide("responsibilityCenterModal");
        }
      });
    },
    showJevModal(record) {
      this.generatedJEV.id = record.id;
      this.generatedJEV.type = record.type;
      this.$bvModal.show("jev-modal");
      this.$store.commit("jev/SET_IS_GENERATING_JEV", true);
      this.$store
        .dispatch("jev/generateJevNumber", {
          cycle: this.cycle,
          campusId: this.selectedCampus,
        })
        .then((response) => {
          if (response.data.error) {
            this.$store.commit("jev/SET_IS_GENERATING_JEV", false);
            return this.showToast(response.data.errorMessage, "error");
          }
          this.$store.commit("jev/SET_IS_GENERATING_JEV", false);
          this.generatedJEV.jevNumber = response.data;
        })
        .catch((error) => {
          this.$store.commit("jev/SET_IS_GENERATING_JEV", false);
          this.showToast(
            "Something went wrong. Cannot generate JEV Number",
            "error"
          );
        });
    },
    postJev() {
      const type = this.jevTypes.find((item) =>
        item.toLowerCase().includes(this.generatedJEV.type.toLowerCase())
      );
      const jevNumber = this.generatedJEV.jevNumber;
      this.$bvModal.hide("jev-modal");
      const typeText = type.split(" - ")[1];
      this.$swal({
        title: "Are you sure?",
        html: `You are now posting this JEV Entry to <span class="text-info">${typeText} Journal</span>. Are you sure you want to post this JEV entry? You won't be able to revert this!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28c76f",
        confirmButtonText: "Yes, post it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("jev/postJev", {
              id: this.generatedJEV.id,
              jevNumber: jevNumber,
            })
            .then((response) => {
              if (response.data.error) {
                this.showToast(response.data.errorMessage, "error");
              } else {
                // this.jevEntries.find(
                //   (item) => item.id === this.generatedJEV.id
                // ).isPosted = true;
                // this.jevEntries.find(
                //   (item) => item.id === this.generatedJEV.id
                // ).jevNumber = jevNumber;
                // this.jevEntries.find(
                //   (item) => item.id === this.generatedJEV.id
                // ).dateTimePosted = new Date().toISOString();
                this.fetchAllJEV();
                this.showToast("Jev successfully posted", "success");
              }
            });
        }
      });
    },
    fetchAllJEV() {
      this.$store
        .dispatch("jev/getAllJevEntry", {
          cycle: this.cycle,
          campusId: this.selectedCampus,
        })
        .then((response) => {
          this.jevEntries = response.data.map((item) => ({
            ...item,
            rotateChevy: false,
            showDetails: false,
          }));
          this.chr = this.jevEntries
            .filter((item) => item.type.toUpperCase() === "CHR")
            .map((item) => ({
              ...item,
              isSLLoading: false,
              subsidiaryLedgers: [],
            }));
          this.chr.sort((a, b) => b.id - a.id);
          this.chd = this.jevEntries
            .filter((item) => item.type.toUpperCase() === "CHD")
            .map((item) => ({
              ...item,
              isSLLoading: false,
              subsidiaryLedgers: [],
            }));
          this.chd.sort((a, b) => b.id - a.id);
          this.ckd = this.jevEntries
            .filter((item) => item.type.toUpperCase() === "CKD")
            .map((item) => ({
              ...item,
              isSLLoading: false,
              subsidiaryLedgers: [],
            }));
          this.ckd.sort((a, b) => b.id - a.id);
          this.ada = this.jevEntries
            .filter((item) => item.type.toUpperCase() === "ADA")
            .map((item) => ({
              ...item,
              isSLLoading: false,
              subsidiaryLedgers: [],
            }));
          this.ada.sort((a, b) => b.id - a.id);
          this.gej = this.jevEntries
            .filter((item) => item.type.toUpperCase() === "GEJ")
            .map((item) => ({
              ...item,
              isSLLoading: false,
              subsidiaryLedgers: [],
            }));
          this.gej.sort((a, b) => b.id - a.id);
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            text: "Cannot fetch JEVs. Please contact your administrator",
          });
        });
    },
    changeCycle(cycle) {
      this.cycle = cycle;
      this.fetchAllJEV();
    },
    changeCampus(data) {
      this.selectedCampus = this.selectedCampus = data.id;
      this.fetchAllJEV();
    },
    repeatForm() {
      this.jevEntryDetails.push({
        jevEntryId: 0,
        accountId: "",
        debit: "0",
        credit: "0",
        isSundry: false,
        dvNumber: null,
        checkNumber: null,
        checkDate: new Date("0001-01-01").toISOString(),
        checkBankName: null,
        payee: null,
      });
    },
    getFundClusters() {
      this.$store
        .dispatch("fundcluster/GetFundCluster")
        .then((res) => {
          const filterAccess = this.$store.state.decrypt
            .userAccessList()
            .filter(
              (item) =>
                item.AccessList.Type.toLowerCase() === "finance" &&
                item.AccessList.ParentId === 118
            );
          console.log(filterAccess);
          const isAdmin = this.$store.state.decrypt.isAdmin();
          if (isAdmin) {
            this.fcOptions = res.data;
          } else {
            filterAccess.forEach((item) => {
              this.fundClusterAccessList.push(
                Number(item.AccessList.Access.split("-")[0])
              );
            });
            this.fcOptions = res.data.filter((item) =>
              this.fundClusterAccessList.includes(item.id)
            );
          }

          this.clusterOptions = this.fcOptions.map((obj) => ({
            value: obj.id,
            text: obj.cluster,
          }));
          this.clusterOptions.unshift({
            value: null,
            text: "Select Fund cluster...",
          });
          this.clusterOptionforTransfer = this.clusterOptions;
        })
        .catch(() => {
          this.alert = {
            type: "danger",
            message:
              "Something went wrong! Cannot fetch fund clusters. Please contact your administrator.",
          };
        });
    },
    processFC(fc) {
      this.fundSources = [];

      if (!fc || !this.selectedCampus) {
        return;
      }

      this.$store
        .dispatch("fundsource/GetFundSourcePerCluster", {
          fundClusterId: fc,
          campusId: this.selectedCampus,
        })
        .then((response) => {
          if (response.data.error) {
            this.showToast(response.data.errorMessage, "error");
            return;
          }
          this.fundSources = response.data.map((item) => ({
            value: item.id,
            text: item.sourceName,
          }));
          this.fundSources.unshift({
            value: null,
            text: "Select Fund Source...",
          });
          // this.pageLoader(false);
        })
        .catch((e) => {
          // this.pageLoader(false);
          this.showToast(
            "Oops. Something went wrong. Please contact your administrator",
            "error"
          );
        });
    },
    removeEntry(item) {
      /** delete jevEntryDetails using key  */
      this.$swal({
        title: "Are you sure?",
        text:
          "Are you sure you want to delete this entry? You can add new entry by click `Add Entry` button",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ea5455",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.jevEntryDetails.splice(this.jevEntryDetails.indexOf(item), 1);
        }
      });
    },
    copyToCredit(key, event) {
      this.jevEntryDetails[key].credit = event;
    },
    compareDebitWithCredit(key, event) {
      if (
        Number(this.getExactAmt(event)) >
        Number(this.getExactAmt(this.jevEntryDetails[key].debit))
      ) {
        if (this.previousCredit === "") {
          this.jevEntryDetails[key].credit = this.jevEntryDetails[key].debit;
        } else {
          this.jevEntryDetails[key].credit = this.previousCredit;
        }
        this.showToast("Credit should not be greater than to Debit", "error");
        return false;
      }
      this.previousCredit = event;
    },
    calculateTotalDebit(record) {
      let sum = 0;
      record.forEach((item) => {
        sum += item.debit;
      });
      return sum;
    },
    calculateTotalCredit(record) {
      let sum = 0;
      record.forEach((item) => {
        sum += item.credit;
      });
      return sum;
    },
    fetchSubsidiaryLedgers() {
      this.$store.commit(
        "subsidiaryledger/SET_SUBSIDIARY_LEDGERS_LOADING",
        true
      );
      this.$store
        .dispatch(
          "subsidiaryledger/getSubsidiaryLedgersByCampus",
          this.selectedCampus
        )
        .then((response) => {
          if (response.data.error) {
            return this.showToast(response.data.errorMessage, "error");
          }
          this.subsidiaryLedgers = response.data;
          this.$store.commit(
            "subsidiaryledger/SET_SUBSIDIARY_LEDGERS_LOADING",
            false
          );
        })
        .catch((error) => {
          this.$store.commit(
            "subsidiaryledger/SET_SUBSIDIARY_LEDGERS_LOADING",
            false
          );
          this.showToast(
            "Oops. Something went wrong. An error encountered during fetching subsidiary leder. Please contact your administrator",
            "error"
          );
        });
    },
    showSubsidiaryLedgerModal() {
      this.$bvModal.show("subsidiaryLedgerModal");
    },
    selectSubsidiaryLedger(data) {
      this.selectedSL = data;
      this.$bvModal.hide("subsidiaryLedgerModal");
    },
    fetchRecord(data) {
      this.selectedSL = data;
      this.fetchSubsidiaryLedgers();
    },
    viewModal(type) {
      this.selectedPrint = type;
      if (
        [
          "ada",
          "chr",
          "ckd",
          "chd",
          "tb",
          "gel",
          "gej",
          "cf",
          "is",
          "dis",
          "bs",
          "dbs",
          "coh",
        ].includes(type.toLowerCase())
      ) {
        this.monthModal = true;
        this.selectedFundCluster = null;
        this.selectedAccount = null;
        this.selectedMonth = null;
      } else {
        this.printReport();
      }
    },
    printReport() {
      if (
        [
          "ada",
          "chr",
          "ckd",
          "chd",
          "tb",
          "gel",
          "gej",
          "cf",
          "is",
          "dis",
          "bs",
          "dbs",
          "coh",
        ].includes(this.selectedPrint.toLowerCase())
      ) {
        if (!["gej"].includes(this.selectedPrint.toLowerCase())) {
          if (
            (!this.selectedMonth || !this.selectedFundCluster) &&
            !["gel"].includes(this.selectedPrint.toLowerCase())
          ) {
            return this.showToast(
              "Cannot Proceed. Please select month and fund cluster to continue",
              "error"
            );
          }
          if (
            (!this.selectedAccount || !this.selectedFundCluster) &&
            ["gel"].includes(this.selectedPrint.toLowerCase())
          ) {
            return this.showToast(
              "Cannot Proceed. Please select account and fund cluster to continue",
              "error"
            );
          }
        } else {
          if (!this.selectedMonth) {
            return this.showToast(
              "Cannot Proceed. Please select month to continue",
              "error"
            );
          }
        }
      }
      const printType = this.selectedPrint.toLowerCase();
      switch (printType) {
        case "ada":
          this.printADA();
          break;
        case "chd":
          this.printCashDisbursement();
          break;
        case "chr":
          this.printCashReceipt();
          break;
        case "ckd":
          this.printCheckDisbursement();
          break;
        case "tb":
          this.printTrialBalance();
          break;
        case "gej":
          this.printGeneralJournal();
          break;
        case "gel":
          this.printGeneralLedger();
          break;
        case "cf":
          this.printCashFlow();
          break;
        case "is":
          this.printIncomeStatement();
          break;
        case "dis":
          this.printDetailedIncomeStatement();
          break;
        case "bs":
          this.printBalanceSheet();
          break;
        case "dbs":
          this.printDetailedBalanceSheet();
          break;
        case "coh":
          this.printCashOnHand();
          break;
      }
    },
    printIncomeStatement() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/IncomeStatement",
        routeVariables: [this.selectedCampus],
        body: {
          cycle: this.cycle,
          fundClusterId: this.selectedFundCluster,
          month: this.selectedMonth,
        },
      });
      this.$bvModal.show("print-options-modal");
      this.selectedMonth = null;
      this.selectedFundCluster = null;
      this.selectedPrint = null;
      this.monthModal = false;
    },
    printDetailedIncomeStatement() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/IncomeStatement/Detailed",
        routeVariables: [this.selectedCampus],
        body: {
          cycle: this.cycle,
          fundClusterId: this.selectedFundCluster,
          month: this.selectedMonth,
        },
      });
      this.$bvModal.show("print-options-modal");
      this.selectedMonth = null;
      this.selectedFundCluster = null;
      this.selectedPrint = null;
      this.monthModal = false;
    },
    printBalanceSheet() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/BalanceSheet",
        routeVariables: [this.selectedCampus],
        body: {
          cycle: this.cycle,
          fundClusterId: this.selectedFundCluster,
          month: this.selectedMonth,
        },
      });
      this.$bvModal.show("print-options-modal");
      this.selectedMonth = null;
      this.selectedFundCluster = null;
      this.selectedPrint = null;
      this.monthModal = false;
    },
    printDetailedBalanceSheet() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/BalanceSheet/Detailed",
        routeVariables: [this.selectedCampus],
        body: {
          cycle: this.cycle,
          fundClusterId: this.selectedFundCluster,
          month: this.selectedMonth,
        },
      });
      this.$bvModal.show("print-options-modal");
      this.selectedMonth = null;
      this.selectedFundCluster = null;
      this.selectedPrint = null;
      this.monthModal = false;
    },
    printCashOnHand() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/CashOnHand",
        routeVariables: [this.selectedCampus],
        body: {
          cycle: this.cycle,
          fundClusterId: this.selectedFundCluster,
          month: this.selectedMonth,
        },
      });
      this.$bvModal.show("print-options-modal");
      this.selectedMonth = null;
      this.selectedFundCluster = null;
      this.selectedPrint = null;
      this.monthModal = false;
    },
    printCashFlow() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/CashFlow",
        routeVariables: [this.selectedCampus],
        body: {
          cycle: this.cycle,
          fundClusterId: this.selectedFundCluster,
          month: this.selectedMonth,
        },
      });
      this.$bvModal.show("print-options-modal");
      this.selectedMonth = null;
      this.selectedFundCluster = null;
      this.selectedPrint = null;
      this.monthModal = false;
    },
    printADA() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Journal/ADA",
        routeVariables: [this.selectedCampus],
        body: {
          cycle: this.cycle,
          fundClusterId: this.selectedFundCluster,
          month: this.selectedMonth,
        },
      });
      this.$bvModal.show("print-options-modal");
      this.selectedMonth = null;
      this.selectedFundCluster = null;
      this.selectedPrint = null;
      this.monthModal = false;
    },
    printCashDisbursement() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Journal/Cash/Disbursement",
        routeVariables: [this.selectedCampus],
        body: {
          cycle: this.cycle,
          fundClusterId: this.selectedFundCluster,
          month: this.selectedMonth,
        },
      });
      this.$bvModal.show("print-options-modal");
      this.selectedMonth = null;
      this.selectedFundCluster = null;
      this.selectedPrint = null;
      this.monthModal = false;
    },
    printCashReceipt() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Journal/Cash/Receipts",
        routeVariables: [this.selectedCampus],
        body: {
          cycle: this.cycle,
          fundClusterId: this.selectedFundCluster,
          month: this.selectedMonth,
        },
      });
      this.$bvModal.show("print-options-modal");
      this.selectedMonth = null;
      this.selectedFundCluster = null;
      this.selectedPrint = null;
      this.monthModal = false;
    },
    printCheckDisbursement() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Journal/Check/Disbursement",
        routeVariables: [this.selectedCampus],
        body: {
          cycle: this.cycle,
          fundClusterId: this.selectedFundCluster,
          month: this.selectedMonth,
        },
      });
      this.$bvModal.show("print-options-modal");
      this.selectedMonth = null;
      this.selectedFundCluster = null;
      this.selectedPrint = null;
      this.monthModal = false;
    },
    printTrialBalance() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Trial/Balance",
        routeVariables: [this.selectedCampus],
        body: {
          cycle: this.cycle,
          fundClusterId: this.selectedFundCluster,
          month: this.selectedMonth,
        },
      });
      this.$bvModal.show("print-options-modal");
      this.selectedMonth = null;
      this.selectedFundCluster = null;
      this.selectedPrint = null;
      this.monthModal = false;
    },
    printGeneralJournal() {
      this.monthModal = false;
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Journal/General",
        routeVariables: [
          this.selectedCampus,
          this.cycle,
          this.selectedMonth,
          this.selectedFundCluster,
        ],
      });
      this.$bvModal.show("print-options-modal");
      this.selectedPrint = null;
      this.selectedMonth = null;
      this.monthModal = false;
    },
    printGeneralLedger() {
      this.monthModal = false;
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/General/Ledger",
        routeVariables: [
          this.selectedCampus,
          this.cycle,
          this.selectedAccount.value,
          this.selectedFundCluster,
        ],
      });
      this.$bvModal.show("print-options-modal");
      this.selectedPrint = null;
      this.selectedFundCluster = null;
      this.selectedAccount = null;
      this.monthModal = false;
    },
  },
  computed: {
    rows() {
      return this.jevEntries.length;
    },
    totalDebit() {
      let total = 0;
      this.jevEntryDetails.forEach((item) => {
        total += Number(this.getExactAmt(item.debit));
      });
      return total;
    },
    totalCredit() {
      let total = 0;
      this.jevEntryDetails.forEach((item) => {
        total += Number(this.getExactAmt(item.credit));
      });
      return total;
    },
    totalPosted() {
      return this.jevEntries.filter((item) => item.isPosted).length;
    },
    totalUnposted() {
      return this.jevEntries.filter((item) => !item.isPosted).length;
    },
  },
  created() {
    this.fetchAccounts();
    this.fetchAllJEV();
    this.getFundClusters();
    this.fetchSubsidiaryLedgers();
    this.campusAccessList = this.$store.state.decrypt
      .campusAccessList()
      .map((item) => ({
        value: item.Id,
        text: item.CampusName,
      }));
    this.campusAccessList.unshift({ value: null, text: "Select Campus..." });
  },
};
</script>
<template>
  <Layout @changeCycle="changeCycle" @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-2 align-self-center">
        <div
          class="card mini-stats-wid"
          role="button"
          @click="selectedJevTypeOption = 'chr'"
        >
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  <i
                    class="bx bx-receipt text-info me-2 align-middle font-size-16"
                  ></i>
                  <span class="align-middle">Cash Receipt</span>
                </p>

                <h4 class="mb-0">{{ chr.length }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 align-self-center">
        <div
          class="card mini-stats-wid"
          role="button"
          @click="selectedJevTypeOption = 'chd'"
        >
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div>
                <p class="text-muted mb-2">
                  <i
                    class="bx bx-money text-warning me-2 align-middle font-size-16"
                  ></i>
                  <span class="align-middle">Cash Disbursement</span>
                </p>
                <h4 class="mb-0">{{ chd.length }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 align-self-center">
        <div
          class="card mini-stats-wid"
          role="button"
          @click="selectedJevTypeOption = 'ckd'"
        >
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div>
                <p class="text-muted mb-2">
                  <i
                    class="bx bx-file text-pink me-2 align-middle font-size-16"
                  ></i>
                  <span class="align-middle">Check Disbursement</span>
                </p>
                <h4 class="mb-0">{{ ckd.length }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 align-self-center">
        <div
          class="card mini-stats-wid"
          role="button"
          @click="selectedJevTypeOption = 'ada'"
        >
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div>
                <p class="text-muted mb-2">
                  <i
                    class="bx bx-wallet-alt text-skyblue me-2 align-middle font-size-16"
                  ></i>
                  <span class="align-middle">Auto Debit</span>
                </p>
                <h4 class="mb-0">{{ ada.length }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 align-self-center">
        <div
          class="card mini-stats-wid"
          role="button"
          @click="selectedJevTypeOption = 'gej'"
        >
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div>
                <p class="text-muted mb-2">
                  <i
                    class="bx bx-book text-success me-2 align-middle font-size-16"
                  ></i>
                  <span class="align-middle">General Journal</span>
                </p>
                <h4 class="mb-0">{{ gej.length }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 align-self-center">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6">
                <div>
                  <p class="text-muted text-truncate mb-2">Not Posted</p>
                  <h4 class="mb-0 text-warning">{{ totalUnposted }}</h4>
                </div>
              </div>
              <div class="col-lg-6">
                <div>
                  <p class="text-muted text-truncate mb-2">Posted</p>
                  <h4 class="mb-0 text-info">{{ totalPosted }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        id="datatable_wrapper"
        class="dataTables_wrapper dt-bootstrap4 no-footer"
      >
        <div class="row mb-3">
          <div class="col-md-12 text-start">
            <div class="d-flex">
              <b-button id="select-report" class="me-2" variant="pink">
                <i class="bx bx-printer align-middle me-2"></i>Reports
              </b-button>
              <b-popover
                target="select-report"
                triggers="click blur"
                placement="left"
                custom-class="popover-report"
              >
                <template v-slot:title>
                  <small>Report List</small>
                </template>
                <div class="my-3">
                  <div class="ms-3 mb-0">
                    <a
                      href="javascript:void(0);"
                      role="button"
                      @click="viewModal('cf')"
                      class="font-size-12 text-dark hoverable-link"
                      >Cash Flow</a
                    >
                  </div>
                  <hr class="my-1 mx-3" />
                  <div class="ms-3 mb-0">
                    <a
                      href="javascript:void(0);"
                      role="button"
                      @click="viewModal('tb')"
                      class="font-size-12 text-dark hoverable-link"
                      >Trial Balance</a
                    >
                  </div>
                  <hr class="my-1 mx-3" />
                  <div class="ms-3 mb-0">
                    <a
                      href="javascript:void(0);"
                      role="button"
                      @click="viewModal('gej')"
                      class="font-size-12 text-dark hoverable-link"
                      >General Journal</a
                    >
                  </div>
                  <hr class="my-1 mx-3" />
                  <div class="ms-3 mb-0">
                    <a
                      href="javascript:void(0);"
                      role="button"
                      @click="viewModal('gel')"
                      class="font-size-12 text-dark hoverable-link"
                      >General Ledger</a
                    >
                  </div>
                  <hr class="my-1 mx-3" />
                  <div class="ms-3 mb-0">
                    <a
                      href="javascript:void(0);"
                      role="button"
                      @click="viewModal('is')"
                      class="font-size-12 text-dark hoverable-link"
                      >Income Statement</a
                    >
                  </div>
                  <hr class="my-1 mx-3" />
                  <div class="ms-3 mb-0">
                    <a
                      href="javascript:void(0);"
                      role="button"
                      @click="viewModal('dis')"
                      class="font-size-12 text-dark hoverable-link"
                      >Detailed Income Statement</a
                    >
                  </div>
                  <hr class="my-1 mx-3" />
                  <div class="ms-3 mb-0">
                    <a
                      href="javascript:void(0);"
                      role="button"
                      @click="viewModal('bs')"
                      class="font-size-12 text-dark hoverable-link"
                      >Balance Sheet</a
                    >
                  </div>
                  <hr class="my-1 mx-3" />
                  <div class="ms-3 mb-0">
                    <a
                      href="javascript:void(0);"
                      role="button"
                      @click="viewModal('dbs')"
                      class="font-size-12 text-dark hoverable-link"
                      >Detailed Balance Sheet</a
                    >
                  </div>
                  <hr class="my-1 mx-3" />
                  <div class="ms-3 mb-0">
                    <a
                      href="javascript:void(0);"
                      role="button"
                      @click="viewModal('coh')"
                      class="font-size-12 text-dark hoverable-link"
                      >Cash on Hand</a
                    >
                  </div>
                </div>
              </b-popover>
              <b-button variant="info" @click="fetchAvailableJev">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                New JEV Entry
              </b-button>
              <b-form-select
                class="form-select w-25 ms-2"
                :options="jevTypeOptions"
                v-model="selectedJevTypeOption"
                @change="updateFilterStatus"
              >
              </b-form-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div v-if="!selectedJevTypeOption">
            <h5>Nothing to display. Please select JEV Entry Type.</h5>
          </div>
          <div v-else>
            <JevTable
              ref="jevtable"
              v-if="selectedJevTypeOption === 'chr'"
              :entries="chr"
              @postJev="showJevModal"
              @viewModal="viewModal"
              type="chr"
              @edit="edit"
              @deleteItem="deleteItem"
              @addtosl="addToSl"
            />

            <JevTable
              :entries="chd"
              ref="jevtable"
              v-if="selectedJevTypeOption === 'chd'"
              @postJev="showJevModal"
              @viewModal="viewModal"
              type="chd"
              @edit="edit"
              @deleteItem="deleteItem"
              @addtosl="addToSl"
            />

            <JevTable
              :entries="ckd"
              ref="jevtable"
              v-if="selectedJevTypeOption === 'ckd'"
              @postJev="showJevModal"
              @viewModal="viewModal"
              type="ckd"
              @edit="edit"
              @deleteItem="deleteItem"
              @addtosl="addToSl"
            />

            <JevTable
              :entries="ada"
              ref="jevtable"
              v-if="selectedJevTypeOption === 'ada'"
              type="ada"
              @postJev="showJevModal"
              @viewModal="viewModal"
              @edit="edit"
              @deleteItem="deleteItem"
              @addtosl="addToSl"
            />

            <JevTable
              :entries="gej"
              ref="jevtable"
              v-if="selectedJevTypeOption === 'gej'"
              type="gej"
              @postJev="showJevModal"
              @viewModal="viewModal"
              @edit="edit"
              @deleteItem="deleteItem"
              @addtosl="addToSl"
            />
          </div>
        </div>
      </div>
      <!-- Modals here -->
      <!-- JEV Number Modal -->
      <b-modal
        title="Confirm JEV Number"
        size="sm"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        id="jev-modal"
        @hidden="generatedJEV.jevNumber = null"
      >
        <div v-if="$store.state.jev.isGeneratingJev">
          <div class="text-center">
            <h5 class="text-secondary mb-0">
              <i class="bx bx-hourglass bx-spin me-2"></i> Fetching data...
            </h5>
          </div>
        </div>
        <div v-else>
          <b-form-group label="JEV No.">
            <b-form-input
              class="form-control"
              v-model="generatedJEV.jevNumber"
            ></b-form-input>
          </b-form-group>
          <div class="modal-footer mt-3">
            <button type="button" @click="postJev" class="btn btn-info">
              <i class="bx bx-upload align-middle me-2"></i>
              Post
            </button>
            <button
              type="button"
              class="btn btn-link"
              @click="$bvModal.hide('jev-modal')"
            >
              Close
            </button>
          </div>
        </div>
      </b-modal>
      <!-- JEV Number Modal -->
      <!-- New Entry Modal -->
      <b-modal
        :title="modalTitle"
        v-model="newJevEntryModal"
        size="xl"
        hide-footer
        no-close-on-backdrop
        @hidden="clearFields"
        no-close-on-esc
      >
        <!-- Type -->
        <b-row>
          <b-col>
            <b-form-group class="mb-3" label="Type" label-for="type">
              <b-form-select
                id="type"
                v-model="newJevEntry.type"
                :options="jevTypes"
                class="form-control"
                @change="toggleCheck"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              class="mb-3"
              label="Responsibility Center"
              label-for="responsibilityCenter"
            >
              <b-input-group>
                <template #append>
                  <b-button
                    v-if="newJevEntry.responsibilityCenter === null"
                    variant="outline-info"
                    @click="searchResponsibilityCenter"
                    ><i class="mdi mdi-clipboard-text-search-outline"></i
                  ></b-button>
                  <b-button
                    v-else
                    @click="newJevEntry.responsibilityCenter = null"
                    variant="outline-danger"
                    title="Remove Responsibility Center Code"
                    ><i class="mdi mdi-close-thick"></i
                  ></b-button>
                </template>
                <b-form-input
                  id="responsibilityCenter"
                  v-model="newJevEntry.responsibilityCenter"
                  type="text"
                  placeholder="Enter Responsibility Center Code..."
                  :class="{
                    'is-invalid':
                      submitted && $v.newJevEntry.responsibilityCenter.$error,
                  }"
                >
                </b-form-input>
                <div
                  v-if="$v.newJevEntry.responsibilityCenter.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.newJevEntry.responsibilityCenter.required"
                    >Responsibility center is required.</span
                  >
                </div>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Description -->
        <b-row>
          <b-col>
            <b-form-group
              class="mb-3"
              label="Description"
              label-for="description"
            >
              <b-form-textarea
                rows="2"
                id="description"
                v-model="newJevEntry.description"
                type="text"
                placeholder="Enter Description..."
                :class="{
                  'is-invalid': submitted && $v.newJevEntry.description.$error,
                }"
              >
              </b-form-textarea>
              <div
                v-if="submitted && $v.newJevEntry.description.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.newJevEntry.description.required"
                  >This value is required.</span
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Reviewing Report -->
        <b-row>
          <b-col>
            <b-form-group
              class="mb-3"
              label="Reviewing Report"
              label-for="reviewingReport"
            >
              <b-form-textarea
                rows="2"
                id="reviewingReport"
                v-model="newJevEntry.reviewingReport"
                type="text"
                placeholder="Enter Reviewing Report..."
              >
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Notes -->
        <b-row>
          <b-col>
            <b-form-group
              class="mb-3"
              label="Additional Notes"
              label-for="notes"
            >
              <b-form-textarea
                rows="2"
                id="notes"
                v-model="newJevEntry.notes"
                type="text"
                placeholder="Enter Notes..."
              >
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Fund Source -->
        <b-row>
          <b-col md="6">
            <b-form-group label="Fund Cluster" class="mb-3">
              <b-form-select
                :options="clusterOptions"
                class="form-select"
                placeholder="Select Fund Cluster..."
                v-model="selectedCluster"
                @change="processFC"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Fund Source">
              <b-form-select
                v-model="newJevEntry.fundSourceId"
                :options="fundSources"
                class="form-select"
                :class="{
                  'is-invalid': submitted && $v.newJevEntry.fundSourceId.$error,
                }"
              ></b-form-select>
              <div
                v-if="submitted && $v.newJevEntry.fundSourceId.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.newJevEntry.fundSourceId.required"
                  >This value is required.</span
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Disbursement Info -->
        <b-row v-if="!hideDisbursement">
          <b-col :md="isOutgoing ? 6 : 12">
            <b-form-group class="mb-3" :label="actor" label-for="payee">
              <b-form-input
                id="payee"
                v-model="newJevEntry.payee"
                type="text"
                :placeholder="`Enter ${actor}...`"
                :class="{
                  'is-invalid': submitted && $v.newJevEntry.payee.$error,
                }"
              >
              </b-form-input>
              <div v-if="$v.newJevEntry.payee.$error" class="invalid-feedback">
                <span v-if="!$v.newJevEntry.payee.required"
                  >{{ actor }} is required.</span
                >
              </div>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="isOutgoing">
            <b-form-group class="mb-3" label="DV Number" label-for="dvNumber">
              <b-input-group>
                <template #append>
                  <b-button
                    v-if="newJevEntry.dvNumber === null"
                    @click="searchDvNumber"
                    variant="outline-info"
                    ><i class="mdi mdi-clipboard-text-search-outline"></i>
                  </b-button>
                  <b-button
                    v-else
                    @click="newJevEntry.dvNumber = null"
                    variant="outline-danger"
                    title="Remove DV Number"
                    ><i class="mdi mdi-close-thick"></i
                  ></b-button>
                </template>
                <b-form-input
                  id="dvNumber"
                  v-model="newJevEntry.dvNumber"
                  type="text"
                  placeholder="Enter DV number..."
                  :class="{
                    'is-invalid': submitted && $v.newJevEntry.dvNumber.$error,
                  }"
                >
                </b-form-input>
              </b-input-group>
              <div
                v-if="$v.newJevEntry.dvNumber.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.newJevEntry.dvNumber.required"
                  >Disbursement number is required.</span
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Check Details -->
        <b-row v-if="forCheck">
          <b-col md="4">
            <b-form-group
              class="mb-3"
              label="Check Number"
              label-for="checkNumber"
            >
              <b-form-input
                id="checkNumber"
                v-model="newJevEntry.checkNumber"
                type="text"
                placeholder="Enter Check number..."
                :class="{
                  'is-invalid': submitted && $v.newJevEntry.checkNumber.$error,
                }"
              >
              </b-form-input>
              <div
                v-if="$v.newJevEntry.checkNumber.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.newJevEntry.checkNumber.required"
                  >Check number is required.</span
                >
              </div>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              class="mb-3"
              label="Check Bank Name"
              label-for="checkBankName"
            >
              <b-form-input
                id="checkBankName"
                v-model="newJevEntry.checkBankName"
                type="text"
                placeholder="Enter Check Bank Name..."
                :class="{
                  'is-invalid':
                    submitted && $v.newJevEntry.checkBankName.$error,
                }"
              >
              </b-form-input>
              <div
                v-if="$v.newJevEntry.checkBankName.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.newJevEntry.checkBankName.required"
                  >Check Bank Name is required.</span
                >
              </div>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group class="mb-3" label="Check Date" label-for="checkDate">
              <date-picker
                id="checkDate"
                v-model="newJevEntry.checkDate"
                :first-day-of-week="1"
                lang="en"
                placeholder="Enter Date Track..."
                :class="{
                  'is-invalid': submitted && $v.newJevEntry.checkDate.$error,
                }"
              ></date-picker>
              <div
                v-if="$v.newJevEntry.checkDate.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.newJevEntry.checkDate.required"
                  >JEV number is required.</span
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- OR Details (Only for Cash Receipts -->
        <b-row v-if="!isOutgoing">
          <b-col md="6">
            <b-form-group class="mb-3" label="OR Number" label-for="orNumber">
              <b-form-input
                id="orNumber"
                v-model="newJevEntry.orNumber"
                type="text"
                placeholder="Enter OR number..."
                :class="{
                  'is-invalid': submitted && $v.newJevEntry.orNumber.$error,
                }"
              >
              </b-form-input>
              <div
                v-if="$v.newJevEntry.orNumber.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.newJevEntry.orNumber.required"
                  >OR number is required.</span
                >
              </div>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group class="mb-3" label="OR Date" label-for="orDate">
              <date-picker
                id="orDate"
                v-model="newJevEntry.orDate"
                :first-day-of-week="1"
                lang="en"
                placeholder="Enter OR Date..."
                :class="{
                  'is-invalid': submitted && $v.newJevEntry.orDate.$error,
                }"
              ></date-picker>
              <div v-if="$v.newJevEntry.orDate.$error" class="invalid-feedback">
                <span v-if="!$v.newJevEntry.orDate.required"
                  >OR Date is required.</span
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <hr class="text-warning" />
        <!-- JEV Details -->
        <div class="d-flex justify-content-between">
          <h4 class="card-title">JEV Details</h4>
          <div class="mb-2">
            <!-- <b-button
              variant="pink"
              class="mt-1"
              size="sm"
              @click="$bvModal.show('template-modal')"
            >
              <span class="align-middle">Select Template</span>
            </b-button>
            <span class="mt-1 mx-2">or</span> -->
            <b-button
              @click="repeatForm"
              variant="info"
              class="pull-right mt-1"
              size="sm"
              >Add more entries</b-button
            >
          </div>
        </div>

        <div class="accordion w-100" role="tablist">
          <b-card
            no-body
            class="mb-0 border-danger"
            v-for="(entry, key) in jevEntryDetails"
            :key="key"
          >
            <b-card-header header-tag="header" class="p-0">
              <b-list-group-item
                button
                action
                tabindex="0"
                v-b-toggle="`entry-${key}`"
                class="list-group-item list-group-item-action text-left"
              >
                <b-row>
                  <b-col md="5">
                    <i
                      class="far fa-list-alt font-size-15 align-middle me-2"
                    ></i>
                    <span class="text-light" v-if="entry.accountId">{{
                      entry.accountId.uacs +
                        ") - " +
                        entry.accountId.accountName
                    }}</span>
                    <span v-else class="text-warning">Add entry info</span>
                  </b-col>
                  <b-col md="3" class="text-right">
                    <span class="text-muted">Debit: </span
                    ><strong class="text-warning">{{
                      formatCurrency(Number(getExactAmt(entry.debit)))
                    }}</strong>
                  </b-col>
                  <b-col md="3" class="text-right">
                    <span class="text-muted">Credit: </span
                    ><strong class="text-warning">{{
                      formatCurrency(Number(getExactAmt(entry.credit)))
                    }}</strong>
                  </b-col>
                  <b-col md="1" class="text-right">
                    <span
                      role="button"
                      class="text-danger"
                      title="Remove Entry..."
                      @click="removeEntry(entry)"
                    >
                      <i class="fas fa-trash-alt font-size-15 align-middle"></i>
                    </span>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-card-header>
            <b-collapse
              :id="`entry-${key}`"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <!-- Account / Debit / Credit / sundry -->
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      class="mb-3"
                      label="Account"
                      label-for="accountId"
                    >
                      <multiselect
                        v-model="entry.accountId"
                        track-by="id"
                        label="accountName"
                        placeholder="Select accounts"
                        :id="`accountId-${key}`"
                        open-direction="above"
                        :custom-label="customLabel"
                        :options="accounts"
                        :searchable="true"
                        :close-on-select="true"
                        :limit="5"
                      >
                      </multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group class="mb-3" label="Debit" label-for="debit">
                      <masked-input
                        autocomplete="off"
                        type="text"
                        v-model="entry.debit"
                        placeholder="Enter Amount..."
                        class="form-control"
                        :mask="currencyMask"
                      >
                      </masked-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                      class="mb-3"
                      label="Credit"
                      label-for="credit"
                    >
                      <masked-input
                        autocomplete="off"
                        type="text"
                        v-model="entry.credit"
                        placeholder="Enter Amount..."
                        class="form-control"
                        :mask="currencyMask"
                      >
                      </masked-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group
                      class="mb-3"
                      label="Sundry?"
                      label-for="isSundry"
                    >
                      <b-form-checkbox
                        id="isSundry"
                        v-model="entry.isSundry"
                        class="mt-3"
                      >
                        <span
                          class="ms-2"
                          :class="{
                            'text-success': entry.isSundry,
                            'text-danger': !entry.isSundry,
                          }"
                          >{{ newJevEntry.isSundry ? "Yes" : "No" }}</span
                        >
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Check -->
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

        <b-card no-body class="mb-0">
          <b-card-header header-tag="header" class="p-0">
            <b-list-group-item
              tabindex="0"
              class="list-group-item list-group-item-action text-left text-info"
              :class="{
                'text-danger':
                  formatCurrency(totalDebit) !== formatCurrency(totalCredit),
              }"
            >
              <b-row>
                <b-col md="5"
                  >Total
                  <span
                    v-if="
                      formatCurrency(totalDebit) !== formatCurrency(totalCredit)
                    "
                    >(UNBALANCE)</span
                  ></b-col
                >
                <b-col md="3" class="text-right"
                  ><strong>{{ formatCurrency(totalDebit) }}</strong></b-col
                >
                <b-col md="3" class="text-right"
                  ><strong>{{ formatCurrency(totalCredit) }}</strong></b-col
                >
                <b-col md="1">&nbsp;</b-col>
              </b-row>
            </b-list-group-item>
          </b-card-header>
        </b-card>

        <hr class="text-info" />

        <b-row class="mb-1" v-if="!selectedSL">
          <b-col md="12">
            <b-button
              size="sm"
              variant="success"
              @click="showSubsidiaryLedgerModal"
            >
              Post to SL
              <i class="mdi mdi-arrow-right ms-1"></i>
            </b-button>
            <!-- <span class="ms-2 me-2"> or </span>
            <b-button variant="warning" @click="$bvModal.show('newSLModal')" size="sm">
              <i class="bx bx-plus me-1 align-middle"></i>
              <span class="align-middle">Create SL</span></b-button
            > -->
          </b-col>
        </b-row>
        <b-row class="mb-1" v-else>
          <span class="text-warning"
            >*** Once saved and posted, JEV details will be added to the
            selected Subsidiary Ledger.</span
          >
        </b-row>
        <b-row v-if="selectedSL">
          <b-col md="12">
            <table
              class="table table-stripped table-hover table-bordered"
              role="table"
            >
              <thead role="rowgroup">
                <th role="columnheader" scope="col" aria-colindex="1" class="">
                  <div>Title</div>
                </th>
                <th role="columnheader" scope="col" aria-colindex="2" class="">
                  <div>Account</div>
                </th>
                <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Reference</div>
                </th>
                <th role="columnheader" scope="col" aria-colindex="3" class="">
                  <div>Action</div>
                </th>
              </thead>
              <tbody role="rowgroup">
                <tr>
                  <td>
                    <h5 class="mb-0 text-info">{{ selectedSL.title }}</h5>
                    <span class="d-block text-muted">{{
                      selectedSL.description
                    }}</span>
                    <span class="badge bg-success">{{
                      selectedSL.type.toUpperCase()
                    }}</span>
                  </td>
                  <td>
                    <span class="badge rounded-pill bg-success">{{
                      selectedSL.account ? selectedSL.account.uacs : "---"
                    }}</span>
                    -
                    <span>{{
                      selectedSL.account
                        ? selectedSL.account.accountName
                        : "---"
                    }}</span>
                  </td>
                  <td>
                    <p class="mb-0">
                      <span>Name: </span
                      ><strong class="text-yellow">{{
                        selectedSL.clientDto ? selectedSL.clientDto.name : "---"
                      }}</strong>
                    </p>
                    <p class="mb-0">
                      <span>Address/Position: </span
                      ><strong class="text-yellow">{{
                        selectedSL.clientDto
                          ? selectedSL.clientDto.addressPosition
                          : "---"
                      }}</strong>
                    </p>
                    <p class="mb-0">
                      <span>Reference Type: </span
                      ><strong class="text-yellow">{{
                        selectedSL.clientDto
                          ? selectedSL.clientDto.type.toUpperCase()
                          : "---"
                      }}</strong>
                    </p>
                  </td>
                  <td class="text-center align-middle">
                    <span
                      role="button"
                      class="text-danger"
                      @click="removeSelectedSL"
                    >
                      Remove
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-alert :variant="alert.type" :show="alert.show" dismissible
          ><i class="mdi mdi-alert-outline me-2"></i>
          {{ alert.message }}</b-alert
        >
        <div class="modal-footer mt-3">
          <button
            type="button"
            @click="createJev(false)"
            class="btn btn-primary"
          >
            <i class="bx bx-save align-middle me-2"></i>
            {{ this.newJevEntry.id > 0 ? "Update" : "Save" }}
          </button>
          <button type="button" @click="saveAndPostJev" class="btn btn-info">
            <i class="bx bx-upload align-middle me-2"></i>
            {{ this.newJevEntry.id > 0 ? "Update & Post" : "Save & Post" }}
          </button>
          <button type="button" class="btn btn-link" @click="closeCreate">
            Close
          </button>
        </div>
      </b-modal>

      <!-- Month Modal -->
      <b-modal
        title="Select Month to Generate"
        v-model="monthModal"
        hide-footer
      >
        <b-form-group label="Cluster" class="mb-2" v-if="selectedPrint">
          <b-form-select
            v-model="selectedFundCluster"
            :options="clusterOptions"
            placeholder="Select cluster..."
            class="form-select"
          >
          </b-form-select>
        </b-form-group>
        <b-form-group
          label="Account"
          class="mb-2"
          v-if="selectedPrint && ['gel'].includes(selectedPrint.toLowerCase())"
        >
          <multiselect
            v-model="selectedAccount"
            track-by="value"
            label="text"
            placeholder="Select account"
            :options="accountOptions"
            :searchable="true"
            :multiple="false"
            :close-on-select="true"
          >
          </multiselect>
        </b-form-group>
        <b-form-group
          label="Month"
          v-if="selectedPrint && !['gel'].includes(selectedPrint.toLowerCase())"
        >
          <b-form-select
            class="form-select"
            :options="monthReports"
            v-model="selectedMonth"
          ></b-form-select>
        </b-form-group>
        <div class="modal-footer pb-0 pe-0">
          <b-button variant="outline-secondary" @click="monthModal = false"
            >Close</b-button
          >
          <b-button variant="purple" @click="printReport">
            <i class="bx bx-printer align-middle me-2 font-size-16"></i>
            <span>Generate</span></b-button
          >
        </div>
      </b-modal>
      <!-- Month Modal -->

      <AvailableDisbursementsModal
        ref="availableDisbursementsModal"
        @selectRow="selectDvNumber"
      />
      <ResponsibilityCenter
        ref="responsibilityCenter"
        :campus="selectedCampus"
        @selectRow="selectResponsibilityCenter"
      />
      <b-modal
        id="subsidiaryLedgerModal"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        title="Select Subsidiary Ledger"
        size="xl"
      >
        <SubsidiaryLedgerList
          ref="SubsidiaryLedgerLis"
          :subsidiaryLedgers="subsidiaryLedgers"
          @selectRow="selectSubsidiaryLedger"
        />
      </b-modal>
      <b-modal
        id="subsidiaryLedgerModalForPosting"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        title="Select Subsidiary Ledger"
        size="xl"
      >
        <SubsidiaryLedgerList
          ref="SubsidiaryLedgerLis"
          :subsidiaryLedgers="subsidiaryLedgers"
          @selectRow="confirmAddtoSL"
        />
      </b-modal>
      <SLModal
        @fetchRecord="fetchRecord"
        :campus="selectedCampus"
        @refreshSL="fetchSubsidiaryLedgers"
      />
      <b-modal id="template-modal" size="lg" hide-footer>
        <CashierTemplates
          @selectTemplate="addAccountsFromTemplate"
          templateType="jev"
        />
      </b-modal>

      <!-- New Entry Modal -->
      <print-options ref="printOpt"></print-options>
    </div>
  </Layout>
</template>
<style lang="scss">
.popover-body {
  padding: 0 !important;
  border: 0 !important;
}

.list-group-item {
  border: 0 !important;
}
</style>
